module.exports = __webpack_public_path__ + "img/bg6.269d530d.png";